import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
import { localNews, nearbyEvents, usefulServices } from '../../data/espace';
function SectionHeading({
  title,
  hint
}: {
  title: string;
  hint?: string;
}) {
  return <div data-id="element-1082" data-mp="1g1v0akghst1s">
      <button type="button" className="group inline-flex items-center gap-2 rounded text-2xl font-extrabold tracking-tight text-ville-navy transition-colors duration-150 ease-ville hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-1083" data-mp="1b4uxqjiuq8ff">
        {title}
        <ChevronRightIcon className="h-6 w-6 text-slate-400 transition-[transform,color] duration-150 ease-ville group-hover:translate-x-0.5 group-hover:text-ville-indigo" aria-hidden="true" data-id="element-1084" data-mp="23rpcczszmdkz" />
      </button>
      {hint && <p className="mt-1 text-[15px] text-slate-500" data-id="element-1085" data-mp="nf0nm9px2xyv">{hint}</p>}
    </div>;
}
export function LocalNews() {
  return <section aria-labelledby="local-news-title" className="mt-12" data-id="element-1086" data-mp="jd5lj305wgk1">
      <h2 id="local-news-title" className="sr-only" data-id="element-1087" data-mp="jg1jgrc0f58h">
        My local news
      </h2>
      <SectionHeading title="My local news" data-id="element-1088" data-mp="1n9v7qujmehr" />

      <ul className="mt-5 grid gap-4 sm:grid-cols-2 xl:grid-cols-3" data-id="element-1089" data-mp="6ophtncdct29">
        {localNews.map(item => <li key={item.id} className="flex" data-id="element-1090" data-mp="3oulqk05zzegl">
            <Link to={item.to ?? '/my-dashboard'} className="group flex w-full overflow-hidden rounded-2xl border border-slate-200 bg-white transition-colors duration-150 ease-ville hover:border-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-1091" data-mp="3otsqtj5ghp7y">
              <img src={item.image} alt="" className="h-auto w-[38%] shrink-0 object-cover" data-id="element-1092" data-mp="3jvr7qy815pwh" />
              <span className="flex min-w-0 flex-1 flex-col p-4" data-id="element-1093" data-mp="357e8nsdnbqxr">
                <span className="text-sm text-slate-500" data-id="element-1094" data-mp="3a4mtk0q6i92p">{item.date}</span>
                <span className="text-[11px] font-bold uppercase tracking-[0.14em] text-ville-indigo" data-id="element-1095" data-mp="3a2tim98j92ow">
                  {item.category}
                </span>
                <span className="mt-1 text-[15px] font-bold leading-snug text-ville-navy" data-id="element-1096" data-mp="3136kpxf0if0l">{item.title}</span>
                <span className="mt-auto pt-3 text-right text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville group-hover:text-ville-indigo" data-id="element-1097" data-mp="16pu9p17ux8sm">
                  Read more
                </span>
              </span>
            </Link>
          </li>)}
      </ul>
    </section>;
}
export function NearbyEvents() {
  return <section aria-labelledby="nearby-events-title" className="mt-12" data-id="element-1098" data-mp="1pn59cmxei48l">
      <h2 id="nearby-events-title" className="sr-only" data-id="element-1099" data-mp="1pmcae84ooj10">
        Events near me
      </h2>
      <SectionHeading title="Events near me" data-id="element-1100" data-mp="1kok94ni5fkk5" />

      <ul className="mt-5 grid gap-4 sm:grid-cols-2 xl:grid-cols-3" data-id="element-1101" data-mp="1gm727vro1gls">
        {nearbyEvents.map(event => <li key={event.id} className="flex" data-id="element-1102" data-mp="1bnme2upoundp">
            <article className="flex w-full overflow-hidden rounded-2xl border border-slate-200 bg-white" data-id="element-1103" data-mp="1bmkshwb1qihq">
              <img src={event.image} alt="" className="h-auto w-[38%] shrink-0 object-cover" data-id="element-1104" data-mp="58v481il7s7j" />
              <div className="flex min-w-0 flex-1 flex-col p-4" data-id="element-1105" data-mp="6mcf8hgaw70">
                <p className="text-sm font-semibold text-ville-indigo" data-id="element-1106" data-mp="2bwbzwc5f5sdc">{event.date}</p>
                {event.time && <p className="text-sm text-slate-500" data-id="element-1107" data-mp="2gtudifudsvro">{event.time}</p>}
                <h3 className="mt-1 text-[15px] font-bold leading-snug text-ville-navy" data-id="element-1108" data-mp="2kw8vkxq87rhw">{event.title}</h3>
              </div>
            </article>
          </li>)}
      </ul>
    </section>;
}
export function UsefulServices() {
  return <section aria-labelledby="useful-services-title" className="mt-12" data-id="element-1109" data-mp="2umtqob6oydw2">
      <h2 id="useful-services-title" className="sr-only" data-id="element-1110" data-mp="2zl4yyhhc8gc6">
        My useful services
      </h2>
      <SectionHeading title="My useful services" hint="Hours and basic information" data-id="element-1111" data-mp="34k8565920slq" />

      <ul className="-mx-5 mt-5 flex snap-x gap-4 overflow-x-auto px-5 pb-2 lg:-mx-10 lg:px-10" data-id="element-1112" data-mp="34idl0t5lx4ip">
        {usefulServices.map(service => <li key={service.id} className="w-[210px] shrink-0 snap-start" data-id="element-1113" data-mp="1a6p10ckiqbrg">
            <article className="h-full overflow-hidden rounded-2xl border border-slate-200 bg-white" data-id="element-1114" data-mp="1a8jl5onytzuh">
              <img src={service.image} alt="" className="h-32 w-full object-cover" data-id="element-1115" data-mp="ixlx6pl783o5" />
              <div className="p-4 text-center" data-id="element-1116" data-mp="izotfrcy2t1b">
                <h3 className="text-[15px] font-bold leading-snug text-ville-navy" data-id="element-1117" data-mp="ewsbm2v8b0yf">{service.name}</h3>
                <p className={`mt-2 text-sm font-bold ${service.open ? 'text-ville-indigo' : 'text-slate-500'}`} data-id="element-1118" data-mp="suqkwtup0772">
                  {service.open ? 'Open' : 'Closed'}
                </p>
                <p className="text-xs text-slate-500" data-id="element-1119" data-mp="6kw9w0ipy1y">{service.hours}</p>
              </div>
            </article>
          </li>)}
      </ul>
    </section>;
}